import React from 'react';
import cn from 'classnames';
import css from './base-input-field.module.scss';

export type BaseInputFieldProps = {
    suffix?: React.ReactNode;
    isInvalid?: boolean;
    align?: 'left' | 'center' | 'right';
    hidePlaceholderOnFocus?: boolean;
} & React.ComponentPropsWithRef<'input'>;

/**
 * This component is used as a base for other input fields.
 * It's not meant to be used directly.
 *
 */
export const BaseInputField = React.forwardRef<
    HTMLInputElement,
    BaseInputFieldProps
>(function BaseInputField(
    {
        isInvalid,
        className,
        style,
        suffix,
        name,
        hidePlaceholderOnFocus,
        ...props
    },
    ref
) {
    return (
        <div
            className={cn(
                css.inputWrapper,
                {
                    [css.error]: isInvalid
                },
                className
            )}
            style={style}>
            <input
                id={name}
                name={name}
                className={cn(css.input, {
                    'text-right': props.align === 'right',
                    'text-center': props.align === 'center',
                    [css.hidePlaceholderOnFocus]: hidePlaceholderOnFocus
                })}
                aria-invalid={isInvalid}
                ref={ref}
                {...props}
            />
            {typeof suffix === 'undefined' ? null : (
                <div className={cn(props.disabled && css.disabled, 'mx-1')}>
                    {suffix}
                </div>
            )}
        </div>
    );
});
